import React from 'react';
import { MDXProvider } from '@mdx-js/react';
import HeadshotContent from '../../mdx/services/headshot.mdx';
import './Headshotdetails.css';

const Paragraph = ({ children, ...props }) => <p className="headshot-details__paragraph" {...props}>{children}</p>;
const Heading = ({ children, ...props }) => <h2 className="headshot-details__heading" {...props}>{children}</h2>;

const images = ['hd1.jpg', 'hd2.jpg', 'hd3.jpg', 'hd4.jpg'];

const Headshotdetails = () => (
  <section className="headshot-details">
    <div className="headshot-details__container">
      <div className="headshot-details__content">
        <MDXProvider components={{ h2: Heading, h3: Heading, p: Paragraph }}>
          <HeadshotContent />
        </MDXProvider>
      </div>
      <div className="headshot-details__gallery">
        {images.map((src, idx) => (
          <div className="headshot-details__item" key={src}>
            <div className="headshot-details__image-wrapper">
              <img src={`${process.env.PUBLIC_URL}/${src}`} alt={`Professional headshot example ${idx + 1}`} className="headshot-details__image" loading="lazy" />
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Headshotdetails;
